import { useAuthStore } from '@/stores/auth';
import { computeTenantSlug } from '@/lib/api';

/**
 * Story FE-Tenant — guard de hidratação para queries tenant-scoped. Resolve pela MESMA
 * cadeia do interceptor (computeTenantSlug), então `enabled: !!useTenantSlug()` e o
 * header X-Tenant-ID nunca divergem: query só dispara quando o header existiria.
 */
export function useTenantSlug(): string | null {
  return useAuthStore(computeTenantSlug);
}
